<template>
  <a-modal
    title="题目编辑"
    style="top: 20px"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :maskClosable="false"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16" style="margin-bottom: 60px">
          <a-col :span="22">
            <a-form-item label="题目" style="width: 100%; margin-bottom: 20px">
              <a-textarea v-model="mdl.title" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="A">
              <a-input v-model="mdl.options[0].A" />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item>
              <label v-if="mdl.answer == 'A'">
                <a-input type="radio" name="rdSpeed" @change="onChange('A')" checked />正确答案标注</label
              >
              <a-input v-if="mdl.answer != 'A'" type="radio" name="rdSpeed" @change="onChange('A')" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="B">
              <a-input v-model="mdl.options[1].B" />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item>
              <label v-if="mdl.answer == 'B'">
                <a-input type="radio" name="rdSpeed" @change="onChange('B')" checked />正确答案标注
              </label>
              <a-input v-if="mdl.answer != 'B'" type="radio" name="rdSpeed" @change="onChange('B')" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="C">
              <a-input v-model="mdl.options[2].C" />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item>
              <label v-if="mdl.answer == 'C'">
                <a-input type="radio" checked name="rdSpeed" @change="onChange('C')" />正确答案标注
              </label>
              <a-input v-if="mdl.answer != 'C'" type="radio" name="rdSpeed" @change="onChange('C')" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row :gutter="7">
          <a-col :span="7">
            <a-form-item label="D">
              <a-input v-model="mdl.options[3].D" />
            </a-form-item>
          </a-col>
          <a-col :span="7">
            <a-form-item>
              <label v-if="mdl.answer == 'D'"
                ><a-input type="radio" checked name="rdSpeed" @change="onChange('D')" />正确答案标注</label
              >
              <a-input v-if="mdl.answer != 'D'" type="radio" name="rdSpeed" @change="onChange('D')" />
            </a-form-item>
          </a-col>
        </a-row>

        <div></div>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { getExamQuestionInfo, updateExamQuestion } from '@/api/master/examinationList'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
export default {
  name: 'examinationEdit',
  props: {},
  components: {},
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      clientInfoPics: [],
      data: '',
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {}
    }
  },
  methods: {
    edit(id) {
      this.mdl = {}
      getExamQuestionInfo(id).then(res => {
        if (res.code === 0) {
          this.mdl = res.data
          this.visible = true
          this.$emit('ok')
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    onChange(e) {
      if (e == 'A') {
        this.mdl.answer = 'A'
      } else if (e == 'B') {
        this.mdl.answer = 'B'
      } else if (e == 'C') {
        this.mdl.answer = 'C'
      } else {
        this.mdl.answer = 'D'
      }
    },
    handleSubmit(e) {
      if (this.mdl.title == null || this.mdl.title == '') {
        this.$message.error('题目名称不能为空')
        return
      }
      if (
        this.mdl.options[0].A == '' ||
        this.mdl.options[1].B == '' ||
        this.mdl.options[2].C == '' ||
        this.mdl.options[3].D == ''
      ) {
        this.$message.error('选项答案不能为空')
        return
      }

      updateExamQuestion(this.mdl).then(res => {
        if (res.code === 0) {
          this.visible = false
          this.$emit('ok')
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },

  watch: {}
}
</script>
<style scoped>
.disEvents {
  pointer-events: none;
}
</style>
